module.exports = __webpack_public_path__ + "static/media/women.f0ad75fb.psd";